import * as PIXI from "pixi.js";
import HowToPlayLayer from "../../../layers/HowToPlayLayer";
import GridFactory from "../../grid/GridFactory";
import { testGridData } from "../../../types/Config";
import { WFireworkInt } from "../../../types/Interface";

export default class HTPGrid extends PIXI.Container {
  private HowToPlayLayer = HowToPlayLayer.getInstance();
  winningFireworks: WFireworkInt[] = [];
  constructor() {
    super();
    this.addGrid();
    this.addToCon();
  }
  addGrid() {
    const grid = new GridFactory(testGridData, 0, true);

    grid.grid.forEach(c => c.forEach(fw => this.addChild(fw)));
    this.winningFireworks = grid.winningFireworks;
  }
  addToCon() {
    this.HowToPlayLayer.addChild(this);
  }
}